import { render } from "./LogsComponent.vue?vue&type=template&id=2a2e3c24&lang=true"
import script from "./LogsComponent.vue?vue&type=script&lang=js"
export * from "./LogsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__